import React from "react";

const Noaccess = () => {
  return (
    <p
      style={{
        textAlign: "center",
        marginTop: "220px",
        fontSize: "2.2em",
        color: "#333",
        fontWeight: "bold",
      }}
    >
      Sorry. You have no access to any of the modules. Please contact the system
      administrator.
    </p>
  );
};

export default Noaccess;
